// Componente Navbar para el layout principal
// Muestra el logo y título del panel

import AmarsiLogo from '../Icons/AmarsiLogo';

/**
 * Componente Navbar
 * 
 * Barra de navegación superior simplificada
 * Muestra solo logo y título del panel
 */
const Navbar = () => {
  return (
    <header className="h-20 flex justify-center items-center justify-center bg-neutral-900 shadow-sm border-b border-neutral-800">
      <AmarsiLogo width="28" height="28" className="sm:w-8 sm:h-8" />
    </header>
  );
};

export default Navbar;
